import { useCallback, useContext, useState } from 'react';
import { useFloating } from '@floating-ui/react';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { QuantAnalysisContext } from '@trinity/chat-components';
import { PopperMenu, PopperMenuItem } from '@trinity/chat-components/components/Popper/index.js';
import { Portal } from '@trinity/chat-components/components/Portal/index.js';
import { useZIndexMiddleware } from '@trinity/chat-components/components/presentation/popper-modifiers.js';
import { MoreVerticalAnchorSmall } from '@/components/presentation/Anchor';
import { useDeleteQuantFolderModal } from '@/components/Project.QuantAnalysis/Modal.DeleteFolder';
import { useRenameQuantFolderModal } from '@/components/Project.QuantAnalysis/Modal.RenameFolder';
import { ProjectDetailsContext } from '@/screens/Project.Main/Context';

type Props = {
  className?: string;
  folderId: number;
  folderName: string;
};

export const FolderContextMenu = (props: Props) => {

  const [open, setOpen] = useState(false);

  const zIndexMiddleware = useZIndexMiddleware();

  const { refs, floatingStyles } = useFloating({
    middleware: [
      zIndexMiddleware,
    ],
    placement: 'bottom-start',
  });

  const handleBlur = useCallback(() => {
    setOpen(false);
  }, []);

  const handleClick = useCallback(() => {
    setOpen(true);
  }, []);

  const quantAnalysis = useContext(QuantAnalysisContext);
  const project = useContext(ProjectDetailsContext);

  const projectId = project.query.data?.project?.id;

  const [toggleDeleteModal, DeleteModal] = useDeleteQuantFolderModal();
  const [toggleRenameQuantFolderModal, RenameModal] = useRenameQuantFolderModal();

  return (
    <>
      <div
        className={props.className}
        ref={refs.setReference}
        onClick={handleClick}>
        <MoreVerticalAnchorSmall
          open={open} />
      </div>
      {open &&
        <Portal>
          <ClickAwayListener
            mouseEvent='onMouseDown'
            onClickAway={handleBlur}
            touchEvent='onTouchStart'>
            <div
              ref={refs.setFloating}
              style={floatingStyles}>
              <PopperMenu>
                <PopperMenuItem onClick={toggleRenameQuantFolderModal}>
                  Rename
                </PopperMenuItem>
                <PopperMenuItem onClick={toggleDeleteModal}>
                  Delete
                </PopperMenuItem>
              </PopperMenu>
            </div>
          </ClickAwayListener>
        </Portal>
      }
      <DeleteModal folderId={props.folderId} />
      <RenameModal
        folderId={props.folderId}
        name={props.folderName}
        projectId={projectId}
        quantAnalysisId={quantAnalysis.id} />
    </>
  );
};
